import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary';
  iconOnly?: boolean;
}
export function Button({
  variant = 'secondary',
  iconOnly = false,
  className = '',
  children,
  ...rest
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-xl text-[13px] font-semibold transition-[color,background-color,transform] duration-150 ease-out active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-accent disabled:cursor-not-allowed disabled:opacity-50';
  const size = iconOnly ? 'h-9 w-9' : 'h-9 px-3.5';
  const look = variant === 'primary' ? 'bg-accent text-on-accent hover:bg-accent/90' : 'border border-line bg-surface text-ink shadow-card hover:bg-canvas';
  return <button type="button" className={`${base} ${size} ${look} ${className}`} {...rest} data-id="element-101" data-mp="2hlf769547egh">
      {children}
    </button>;
}